import AuthFormActionButton from "./AuthFormActionButton";
import notifyServerOfSignup from "./notifyServerOfSignup";
import SupportSigninButton from "./SupportSigninButton";
import FormField from "./FormField";
import usePresentSelector from './usePresentSelector';
import { useState, useEffect } from 'react';

import G from './Getters';
import A from './ActionCreators';
import { useSelector, useDispatch } from 'react-redux';

export const forms = {
  signin:{
    formLines:['email','password'],
    action:"Login",
    alternative:{
      scene:'forgot',
      text:'Forgot password?'
    }
  },
  signup:{
    formLines:[['firstName','lastName'],'email','password','confirmPassword','signupReference'],
    optional:(new Set(['signupReference'])),
    action:'Sign up!',
  },
  forgot:{
    formLines:['email'],
    action:'Send Code to Email',
  },
  changePassword:{
    placeholders:{
      password:'New password',
    },
    action:'Reset Password',
    formLines:['code','password','confirmPassword'],

  }
}

const createEmptyForm = (scene) => {
  return Object.fromEntries(
    forms[scene].formLines.flat().map(key => ([key,'']))
  )
  
}

const ErrorMessage = ({msg,scene,messageType}) => (

  <div messagetype={messageType} form={scene} formComponentType={"error-message"} style={{color:'red', fontSize:18}} class="bold">{msg}</div>

)



const FormLine = ({scene,fieldNameData,form,setForm}) => {

  return (
    <div class="sg-row">
      {[fieldNameData].flat().map(field => <FormField {...{
        key:field,
        scene,
        field,form,setForm
      }}/>)}
    </div>
  )

}




export default function AuthForm({scene,setScene}){


  const dispatch = useDispatch();

  let [form,setForm] = useState(createEmptyForm(scene));
  let [ responses, setResponses ] = useState({});

  let [ succesfulSignup, setSuccessfulSignup ] = useState(false);
  let isProcessing = usePresentSelector(state => !!state.loginInfo.authPending)
  let [loginAttempt, setLoginAttempt] = useState();


  let route = usePresentSelector(state => state.route || 'guest');

  

  let { lastAuthAttemptId, serverResponseMessage } = usePresentSelector(state => {
    let lastAuthAttemptId = G.getAuthAttemptId(state)
    let serverResponseMessage = G.getAuthResponseMessage(state)
    return { lastAuthAttemptId, serverResponseMessage };
  });

  useEffect(() => {

    if( loginAttempt !== lastAuthAttemptId ){
      setLoginAttempt(lastAuthAttemptId);
      setResponses({server:serverResponseMessage});
    }
  })

  if( succesfulSignup ){
    return null;//signupText;
  }

  if( responses.server ){
    debugger;
  }




  let errorMessage = (loginAttempt && responses.server) || responses.client;

  let messageType = Object.keys(responses).find(x => x);


  return (

    <div class="tiny-padding" style={{
      textAlign:'center',
      width:'100%',
      //border:'3px solid yellow',
      }}>


      {errorMessage && <ErrorMessage {...{messageType, msg:errorMessage,scene}}/>}

      {forms[scene].formLines.map( fieldNameData => (
        <FormLine {...{scene,fieldNameData,form,setForm}}/>
      ))}

      <div style={{color:'red',fontWeight:'bold'}}>

      </div>

      <div 
        class="small-margin-left small-margin-right small-margin-top"
      >
       
        <AuthFormActionButton {...{
          isProcessing,
          scene,
          setScene,
          setResponses,
          dispatch,
          A,
          form,
          forms,
          route,
        }}/>
        {forms[scene].alternative && (<div style={{
        }}>
          <button 
            goto={forms[scene].alternative.scene}
            onClick={() => setScene(forms[scene].alternative.scene) } class="small-margin alternative btn btn-link">
            {forms[scene].alternative.text}
          </button>
        </div>)}
      </div>

      {
        (scene === 'signin') && (
          <>
            <div class="fair-margin-bottom">
              <div class="full-width med-border-bottom"/>
            </div>

              <button style={{
                width:'90%',
                }} button={"create-account"} onClick={() => setScene('signup')} class="btn btn-success bold fair-margin-bottom">
                Create account
              </button>
                
            <SupportSigninButton/>
          </>
        )
      }
    </div>

  )

}
